// Modalità embed tablet (YELLGO-6125): l'app cameriere è incorporata in iframe dal selforder.
// Il token operatore arriva via postMessage dalla pagina genitore (mai in URL né in localStorage)
// e ogni messaggio è accettato solo dall'origine che incorpora l'iframe.

const queryParams = new URLSearchParams(window.location.search);

export const isEmbedded = window.parent !== window;
export const isTabletEmbed = isEmbedded && queryParams.get("embed") === "tablet";
export const embedShopId = isTabletEmbed ? queryParams.get("shop_id") : null;

const getParentOrigin = () => {
  try {
    if (document.referrer) return new URL(document.referrer).origin;
  } catch (e) {}
  const ancestors = window.location.ancestorOrigins;
  return ancestors && ancestors.length > 0 ? ancestors[0] : null;
};

const parentOrigin = isTabletEmbed ? getParentOrigin() : null;

export function postToParent(message) {
  if (!isTabletEmbed || !parentOrigin) return;
  window.parent.postMessage({ source: "yellgo-waiter", ...message }, parentOrigin);
}

// Chiede il token al genitore; restituisce la funzione per annullare l'ascolto.
export function requestEmbedToken(onToken) {
  const listener = (event) => {
    if (event.source !== window.parent || event.origin !== parentOrigin) return;
    const data = event.data;
    if (!data || data.source !== "yellgo-selforder" || data.type !== "auth" || !data.token) return;
    onToken(data.token);
  };
  window.addEventListener("message", listener);
  postToParent({ type: "ready" });
  return () => window.removeEventListener("message", listener);
}
